<template>
  <el-dialog custom-class="le-icons-list-dialog" :append-to-body="true" :destroy-on-close="true" :title="title" top="10vh" :visible.sync="visible" width="990px" @close="handleClose">
    <div v-loading="loading" class="icon-dialog-body">
      <div class="dialog-search-row">
        <el-form :inline="true" label-width="80px" class="icon-from">
          <el-form-item label="资源名称">
            <el-input v-model="queryForm.name" :clearable="true" />
          </el-form-item>
          <el-form-item label=" " label-width="10px">
            <el-button native-type="submit" type="primary" @click="handleQueryEvent">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="dialog-content-row">
        <template v-if="page.total > 0">
          <div v-if="iconTypes.length > 0" class="icon-card-row">
            <el-tabs v-model="queryForm.iconType" class="le-icons-tabs" @tab-click="handleTabsClickEvent">
              <template v-for="item in iconTypes">
                <el-tab-pane :key="item[dataField.id] || item[dataField.name]" :label="item[dataField.name]" :name="item[dataField.name]" />
              </template>
            </el-tabs>
          </div>

          <div class="icon-row">
            <div v-for="item in page.records" :key="item[dataField.id]" class="icon-col">
              <icon-item :is-selected="item.itemSelected" :icon-type="iconType" :icon="item[dataField.content]" :text="item[dataField.name]" :img-render="imgRender" @click="handleItemClick($event, item)" />
            </div>
          </div>
        </template>

        <el-empty v-if="page.total === 0" :description="emptyInfo" />
      </div>

      <div v-if="page.total > 0" class="dialog-paging-row">
        <el-pagination
          class="le-icons-paging"
          :background="true"
          :current-page="queryForm.pageNum"
          :page-size="queryForm.pageSize"
          :page-sizes="[40, 80, 160, 240, 500]"
          :total="page.total"
          layout="prev, pager, next, total, jumper"
          @current-change="handleCurrentChangeEvent"
          @size-change="handleSizeChangeEvent" />
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import IconItem from './icon_item';
import iconArray from './data/icon.json';

export default {
  name: 'IconList',
  components: {IconItem},
  props: {
    iconType: {
      type: String,
      default: 'icon'
    },
    initData: {
      type: [Array, Function],
      default: null
    },
    imgRender: {
      type: Function,
      default: (icon) => {
        return icon;
      }
    },
    props: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      visible: false,
      title: '资源展示列表',
      loading: true,
      emptyInfo: '暂无资源',
      queryForm: {
        pageNum: 1,
        pageSize: 40,
        name: '',
        iconType: ''
      },
      iconTypes: [],
      selectedItem: {},
      page: {
        total: 0,
        records: []
      }
    };
  },
  computed: {
    dataField() {
      return {
        id: this.props?.id || 'id',
        name: this.props?.name || 'name',
        content: this.props?.content || 'content',
        result: this.props?.result || 'content',
        itemArray: this.props?.itemArray || 'itemArray'
      };
    }
  },
  methods: {
    loadDataList() {

      // 验证initData是否为空
      if (this.iconType !== 'icon' && !this.initData) {
        this.emptyInfo = '未指定资源数组或获取资源函数';
        this.loading = false;
        return;
      }

      // icon 图标，image 图片，shape 内置图形
      if (this.iconType === 'icon' && !this.initData) {
        // 加载默认图标数据
        this.loadIconList();
        return;
      }

      if (typeof this.initData === 'object' && this.initData instanceof Array) {
        this.handleCustomResourceData(this.queryForm, this.initData);
        return;
      }

      if (typeof this.initData === 'function') {
        this.initData().then(resp => {
          if (Object.hasOwn(resp, 'data')) {
            this.handleCustomResourceData(this.queryForm, resp?.data);
          } else {
            this.emptyInfo = 'initData 返回格式错误，使用函数初始化数据时，返回值需要包括 data 属性';
            this.loading = false;
          }
        });
        return;
      }

      this.emptyInfo = 'initData 参数格式错误，只能是数组或函数';
      this.loading = false;
    },
    loadIconList() {
      this.iconTypes = this.handleIconTypes(iconArray);
      let iconItem = iconArray[0];
      if (this.queryForm.iconType) {
        iconItem = iconArray.find(item => item[this.dataField.name] === this.queryForm.iconType);
      } else {
        this.queryForm.iconType = iconItem[this.dataField.name];
      }

      this.page = this.handleResourceData(this.queryForm, iconItem[this.dataField.itemArray]);
      this.loading = false;
    },
    handleShow() {
      this.visible = true;
      this.loadDataList();
    },
    handleConfirm() {
      this.visible = false;
      this.$emit('change', this.selectedItem[this.dataField.result], this.selectedItem);
    },
    handleClose() {
      this.handleClearData();
      this.visible = false;
    },
    handleItemClick($event, item) {
      const iconItem = this.page.records?.find(item => item.itemSelected);
      if (iconItem) {
        this.$set(iconItem, 'itemSelected', false);
      }
      this.$set(item, 'itemSelected', $event);
      this.selectedItem = item;
    },
    handleTabsClickEvent() {
      this.queryForm.pageNum = 1;
      this.loadDataList();
    },
    handleQueryEvent() {
      this.queryForm.pageNum = 1;
      this.loadDataList();
    },
    handleCurrentChangeEvent(val) {
      this.queryForm.pageNum = val;
      this.loadDataList();
    },
    handleSizeChangeEvent(val) {
      this.queryForm.pageSize = val;
      this.loadDataList();
    },
    handleResourceData(params, dataArray) {
      if (!params || !dataArray || dataArray.length === 0) {
        return {total: 0, records: []};
      }

      // 名称匹配过滤数据
      let filterArray = dataArray;
      if (params.name) {
        filterArray = dataArray?.filter(item => item[this.dataField.name].indexOf(params.name) > 0);
      }

      const records = filterArray?.filter((item, index) => {
        this.$set(item, 'itemSelected', false);
        return index < params.pageSize * params.pageNum &&
          index >= params.pageSize * (params.pageNum - 1);
      });

      return {
        total: filterArray.length,
        records: records
      };
    },
    handleCustomResourceData(params, dataArray) {
      if (!params || !dataArray || dataArray.length === 0) {
        return;
      }
      
      const typeArray = this.handleIconTypes(dataArray);
      let page = null;
      if (typeArray.length > 0) {
        let dataItem = dataArray[0];
        if (params.iconType) {
          dataItem = dataArray.find(item => item[this.dataField.name] === params.iconType);
        } else {
          this.queryForm.iconType = dataItem[this.dataField.name];
        }
        page = this.handleResourceData(params, dataItem[this.dataField.itemArray]);
      } else {
        this.handleResourceData(params, dataArray);
      }

      this.iconTypes = typeArray;
      this.page = page;
      this.loading = false;
    },
    handleIconTypes(dataArray) {
      if (!dataArray) {
        return [];
      }

      return dataArray.filter(item => Object.hasOwn(item, this.dataField.itemArray));
    },
    handleClearData() {
      this.iconTypes = [];
      this.queryForm = this.$options.data().queryForm;
      this.page = {total: 0, records: []};
    }
  }
};
</script>

<style lang="scss" scoped>

@import "../../static/styles/commons/icon";

/deep/ .le-icons-list-dialog {
  * {
    // border-box IE传统的Box Model，  content-box W3C的标准Box Model
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
  }

  .el-dialog__header {
    border-bottom: 1px solid #ebeef5;
  }

  .el-dialog__title {
    font-weight: 400;
  }

  .el-dialog__body {
    padding: 15px;
  }

  .icon-from {
    .el-form-item__label {
      padding-right: 5px;
    }


    .el-form-item--small.el-form-item {
      margin: 0;
    }
  }

  .el-button, .el-input__inner {
    border-radius: 2px;
  }

  .le-icons-tabs {

    .el-tabs__header {
      margin: 0 0 10px;
    }

    .el-tabs__item {
      padding: 0 15px;
    }

    .el-tabs__item.is-top:nth-child(2) {
      padding-left: 15px;
    }
  }
}

.icon-dialog-body {

  .icon-card-row {
    padding-bottom: 5px;
  }

  .dialog-search-row, .dialog-content-row {
    margin-bottom: 15px;
  }

  .icon-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
  }

  .icon-col {
    padding: 5px;
  }

  .le-icons-paging {
    padding: 2px 0;
  }
}
</style>
